import { useTranslation } from 'react-i18next';
import useUrlParams from '../../../hooks/useUrlParams';
import plug_image from '../../../images/plug-image.webp';

export default function FreePlanPlaceholder() {
  const { t, i18n } = useTranslation();
  const { baseUrl } = useUrlParams();
  const localePart = i18n.language === 'en' ? '' : `/${i18n.language}`;
  const upgradeUrl = `${baseUrl}${localePart}/for-organizers/payment-subscription/`;

  return (
    <div className="d-flex col-12 align-items-center justify-content-center mt-5 py-5 flex-column text-center gap-4">
      <img src={plug_image} alt="plug placeholder" height={222} />
      <div className="text-gray fs-6 col-10 col-md-4 col-lg-4 px-lg-5">
        {t(
          'ticketStatistic.freePlanDescription',
          'Get access to detailed statistics and track your event performance with the Pro plan.'
        )}
      </div>
      <a
        href={upgradeUrl}
        target="_blank"
        rel="noreferrer"
        className="btn btn-primary-me-ticket py-3 col-11 col-md-4 col-lg-3 text-white fw-bold"
        style={{ maxWidth: 262 }}
      >
        {t('ticketStatistic.upgradeToPro', 'Upgrade to Pro')}
      </a>
    </div>
  );
}
